export default {
  strict: true,
  namespaced: true,
  state: {
    list: [],
    loading: false,
    search: '',
    currentPage: 1,
    perPage: 20,
    order: 'id',
    orderAsc: '',
    maxList: 20,
  },
  mutations: {
    setListData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/flights/list.js